<template>
  <div class="uploading-page">
    <div class="img-box">
      <h1>{{ content !== null ? content : $t('LAYOUT.uploading.___title') }}</h1>
      <img :src="require('../../assets/images/upload.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: () => ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/uploading.vue